import React from "react";

// Custom Styled Item
export const StyledItem = ({
    active,
    depth,
    config,
    disabled,
    children,
    ...props
}) => {
    const subItem = depth !== 1;

    const indentClass = depth === 1 ? "pl-2" : depth >= 2 ? "pl-4" : "";

    const baseClasses = `
    flex items-center w-full ${indentClass}
    rounded-md transition-colors duration-200
    ${disabled ? "cursor-not-allowed text-gray-400" : "cursor-pointer"}
  `;

    const activeClasses = subItem
        ? "bg-transparent text-black hover:bg-gray-100"
        : "bg-red-50 text-gray-900 font-semibold hover:bg-red-100";

    const inactiveClasses = "text-gray-600 hover:bg-gray-100";

    return (
        <div
            {...props}
            className={`${baseClasses} px-2 py-1 mb-${config.itemGap} ${
                active ? activeClasses : inactiveClasses
            }`}
        >
            {children}
        </div>
    );
};

// Custom Icon wrapper
export const StyledIcon = ({ size = 20, children }) => (
    <div
        className="flex items-center justify-center shrink-0"
        style={{ width: size, height: size }}
    >
        {children}
    </div>
);

// Dot icon
export const StyledDotIcon = ({ active }) => (
    <span
        className={`
      w-1 h-1 rounded-full transition-transform
      ${active ? "scale-150 bg-blue-600" : "bg-gray-400"}
    `}
    />
);

// Subheader
export const StyledSubheader = ({ config, children, ...props }) => (
    <div
        {...props}
        className={`
      text-[11px] inline-flex cursor-pointer transition-colors
      px-2 pt-4 pb-2 mb-${config.itemGap}
      text-gray-400 hover:text-black
    `}
    >
        {children}
    </div>
);
